<template>
  <div class="display-wrapper fullscreen-wrapper">
    <fullscreen :fullscreen.sync="isFullscreen" style="background-color: #101129 !important;">
      <div class="display-content" v-if="toReload" style="position:relative">
        <div
          style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 35px;
                left: 0;
              "
        >
              <span @click="toggleApi" style="margin-right:2rem">
                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                <span class="fullscreen-btn" v-else>退出全屏</span>
              </span>
          <span @click="goback">
                <span class="fullscreen-btn">返回首页</span>
              </span>
        </div>
        <div
          style="
                width: 98%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 85px;
                left: 25px;
              "
        >
          <button class="cool-button" @click="goData" >综合数据</button>
          <button class="cool-button-active">体教融合</button>
          <button class="cool-button" @click="goOrgan" >组织架构</button>
          <button class="cool-button" @click="goSite" >基础设施</button>
          <button class="cool-button" @click="goKeyCity">重点城市</button>
        </div>
          <!--左半边-->
          <div class="column left">
            <!--精英机构数量-->
            <div class="row class-all">
              <div class="com-wrapper">
                <statistical-com
                  :numStatistical="propsSchoolMan"
                  :title="'【男足】精英机构合作学校数量'"
                ></statistical-com>
              </div>
            </div>

            <!--球队饼状图-->
            <div class="row class-all">
              <div class="pie-wrapper">
                <template v-if="isShowChild">
                  <pie-com
                    :propsReloadTime="reloadTime"
                    :statisticsSquadLevel = "statisticsSquadLevelVosMan"
                    :schoolComplete="schoolComplete"
                    :title="'【男足】在校球员分布'"
                  ></pie-com>
                </template>
              </div>
            </div>
          </div>
          <!--中间-->
          <div class="column center">
            <!--地图-->
            <div class="map-canvas">
              <div class="map-title">
                <!-- {{ year }}年各省/自治区/直辖市/特别行政区开班数量 -->
                <p style="font-weight: bold;">体教融合大数据</p>
                <br>
                <p style="color: #ffbd57;">精英机构合作学校在校球员：{{stuNumAll+stuNumAllWomen}} 人</p>
              </div>
              <div class="echart-map-wrapper" style="color:white" >
                <template v-if="isShowChild">
                  <div style="text-align: center">
                    <img :src="yiyi" alt="" width="130" height="320" style="margin-top:2.5rem">
                    <p style="color: #ffbd57; margin-top:3rem;font-weight:bold;font-size:15px">男：{{stuNumAll}} 人</p>
                  </div>
                  <div style="text-align: center">
                    <img :src="keke" alt="" width="150" height="300" style="margin-top:4rem">
                    <p style="color: #ffbd57; margin-top:3.4rem;font-weight:bold;font-size:15px">女：{{stuNumAllWomen}} 人</p>
                  </div>

                </template>
              </div>
            </div>
          </div>
          <!--右半边-->
          <div class="column right">
            <!--训练计划数量-->
            <div class="row class-all">
              <div class="toturial-wrapper">
                <statistical-com
                  :numStatistical="propsSchoolWomen"
                  :title="'【女足】精英机构合作学校数量'"
                ></statistical-com>
              </div>
            </div>

            <div class="row class-all">
              <div class="pie-wrapper">
                <template v-if="isShowChild">
                  <pie-com-women
                    :propsReloadTime="reloadTime"
                    :statisticsSquadLevel = "statisticsSquadLevelVosWomen"
                    :title="'【女足】在校球员分布'"
                    :schoolComplete="schoolCompleteWomen"
                  ></pie-com-women>
                </template>
              </div>
            </div>
          </div>

      </div>
      <div class="display-content" style="background: none; padding: 0px 0.8rem;" v-if="toReload">
        <div class="column">
          <div class="row class-all">
            <div class="line-wrapper">
              <template v-if="isShowChild">
                <line-com
                  :schoolComplete="manSchoolComplete"
                  :playerNum="playerNum"
                  :playerNumZhong="playerNumZhong"
                  :playerNumGao="playerNumGao"
                  :playerKey="playerKey">
                </line-com>
              </template>
            </div>
          </div>
        </div>
        <div class="column" style="margin-left:0.8rem">
          <div class="row class-all">
            <div class="line-wrapper">
              <template v-if="isShowChild">
                <line-com-women
                  :schoolComplete="womanSchoolComplete"
                  :playerNum="playerNumWomen"
                  :playerNumZhong="playerNumZhongWomen"
                  :playerNumGao="playerNumGaoWomen"
                  :playerKey="playerKey">
                </line-com-women>
              </template>
            </div>
          </div>
        </div>
      </div>

    </fullscreen>
  </div>
</template>

<script>
  import VueFullscreen from "vue-fullscreen";
  import Vue from "vue";
  import  statistics  from "@/api/statistics";
  import yiyi from '@/assets/images/common/yioks_yiyi1.png'
  import keke from '@/assets/images/common/yioks_keke2.png'
  Vue.use(VueFullscreen);

  export default {
    data() {
      return {
        yiyi,
        keke,
        fullscreen: false,
        isFullscreen: false,
        toReload: true,
        mapName: "echartsTestProvince",
        mapProvinceName: "上海",
        isShowChild: true,
        statisticsToCounty:{},// 精英机构分布区县

        playerNum: [], // 球员数量
        playerNumZhong: [], // 球员数量
        playerNumGao: [], // 球员数量
        playerNumWomen: [], // 球员数量
        playerNumZhongWomen: [], // 球员数量
        playerNumGaoWomen: [], // 球员数量
        playerKey: [], // 球员所在机构简称
        reloadTime: 30000,  // ms
        type: 'allYouth',  // ms
        propsSchoolMan:{},
        propsSchoolWomen:{},
        propsSchoolStuMan:{},
        propsSchoolStuWomen:{},
        statisticsSquadLevelVosMan:{},// 球队饼状图
        statisticsSquadLevelVosWomen:{},// 球队饼状图
        stuNumAll:0,
        stuNumAllWomen:0,
        manSchoolComplete:'',
        womanSchoolComplete:'',
        schoolCompleteWomen:{},// 完成女足321体系的机构
        schoolComplete:{},//完成男足631体系的机构
      };
    },

    components:{
      "statistical-com": () => import("./SchoolStatistics/SexNumStatistical"), // 精英机构数量统计
      "pie-com": () => import("./SchoolStatistics/StuNumStatistics"), // 球队统计
      "pie-com-women": () => import("./SchoolStatistics/StuNumStatisticsWomen"), // 球队统计
      "teacher-com": () => import("./components/CoachStatistics"), // 教练统计
      "map-com": () => import("./EchartsProvinceSchool"), // 地图
      "line-com": () => import("./SchoolStatistics/StuNumToYouthStatistics"), // 球员统计
      "line-com-women": () => import("./SchoolStatistics/StuNumToYouthStatisticsWomen"), // 球员统计
      "toturial-com": () => import("./components/PlanStatistical"), // 训练计划数量
      "waterFall-com": () => import("./components/PlanData"), // 训练计划滚动
      "tutorial-line-com": () => import("./components/TeachingStatistics"), // 教案库统计
    },

    computed: {

    },

    mounted() {
      this.isShowChild = false;
      this.loadInfo();
      document.getElementsByTagName('html')[0].style.fontSize = '11px';
    },

    destroyed() {
      document.getElementsByTagName('html')[0].style.fontSize = '10.672358591248667vh';
    },


    methods: {
      toggleApi() {
        const that = this;
        this.$fullscreen.toggle(this.$el.querySelector(".fullscreen-wrapper"), {
          teleport: this.teleport, // 如果为true， 进入全屏时目标元素会被移动到document.body下；
          callback: (isFullscreen) => {
            that.fullscreen = isFullscreen;
          },
        });
      },
      goData(){
        this.$router.push({
          path: '/statistics',
        })
      },
      goSite(){
        this.$router.push({
          path: '/statisticsSiteFacilities',
        })
      },
      goKeyCity(){
        this.$router.push({
          path: '/statisticsKeyCityTrain',
        })
      },
      goOrgan(){
        this.$router.push({
          path: '/statisticsOrganizational',
        })
      },
      goback(){
        this.$router.push({
          path: '/',
        })
      },
      loadInfo() {
        statistics.getSchoolStatistics()
        .then(res => {
          const {
            schoolMan,  // 男足学校数量
            schoolWomen,  // 女学校数量
            schoolStuMan,  // 男足在校人数
            schoolStuWomen,  // 女足在校人数
            playerNumVos,  // 机构的学校数量
            stuNumVoMan,
            stuNumVoWomen,
            statisticsToCounty,
            stuNumAll,
            stuNumAllWomen,
            womanSchoolComplete,
            manSchoolComplete,
            schoolComplete,
            schoolCompleteWomen
          } = res;

          // region 球员柱状图
//          let playerNum = [356,415,221,132,231,259,165,123,147,159,164,241,211,312,154,366]; // 测试球员数据数量
          let playerNum = []; // 球员数量
          let playerNumZhong = []; // 球员数量
          let playerNumGao = []; // 球员数量
          let playerNumWomen = []; // 球员数量
          let playerNumZhongWomen = []; // 球员数量
          let playerNumGaoWomen = []; // 球员数量
          let playerKey = []; // 球员所在机构简称
          if(playerNumVos && playerNumVos.length) {
            playerNumVos.forEach((item,index) => {
              playerNum[index] = item.numXiao;
              playerNumZhong[index] = item.numZhong;
              playerNumGao[index] = item.numGao;
              playerNumWomen[index] = item.numXiaoWomen;
              playerNumZhongWomen[index] = item.numZhongWomen;
              playerNumGaoWomen[index] = item.numGaoWomen;
              playerKey[index] = item.playerKey;
            });
          }
          this.playerNum = playerNum;
          this.playerNumZhong = playerNumZhong;
          this.playerNumGao = playerNumGao;
          this.playerNumWomen = playerNumWomen;
          this.playerNumZhongWomen = playerNumZhongWomen;
          this.playerNumGaoWomen = playerNumGaoWomen;
          this.playerKey = playerKey;
          // endregion

          this.propsSchoolMan = schoolMan;
          this.propsSchoolWomen=schoolWomen;
          this.propsSchoolStuMan=schoolStuMan;
          this.propsSchoolStuWomen=schoolStuWomen;
          this.statisticsSquadLevelVosMan = stuNumVoMan;
          this.statisticsSquadLevelVosWomen = stuNumVoWomen;
          this.statisticsToCounty = statisticsToCounty;
          this.stuNumAll = stuNumAll;
          this.stuNumAllWomen = stuNumAllWomen;
          this.manSchoolComplete = manSchoolComplete;
          this.womanSchoolComplete = womanSchoolComplete;
          this.schoolComplete = schoolComplete;
          this.schoolCompleteWomen = schoolCompleteWomen;


          this.isShowChild = true; // 开始画图
        })
        .catch((err) => {
          console.error("err", err);
        });
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable1'
  .display-wrapper
    width 100%
    height 100%
    font-size 12px !important
    background-color #101129 !important
  .display-content
    font-size 12px !important
    background-color #101129 !important
    min-width 1680px
    max-width 1920px
    margin 0 auto
    display flex
    padding 9rem 0.8rem 0
    background url('../../assets/images/display/logo.png') no-repeat 0 0 / contain
    .cool-button
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #60c5e9, #2a4d6a);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .cool-button:hover
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      transform: skew(-15deg) translateY(-2px); /* 保持倾斜并提升按钮位置 */
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    .cool-button-active
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .column
      position relative
      flex 3
      .row
        box-sizing border-box
        border 2px solid red
        border-image url('../../assets/images/display/border.png') 51 38 21 132
        border-width 4.125rem 1.583rem 0.875rem 5.5rem
        position relative
        margin-bottom 5rem
        color #FFFFFF
      .row-content
        position absolute
        top -4rem
        right -1.5rem
        bottom -0.875rem
        left -5.5rem
        padding 1.25rem 2rem
      .class-all
        min-height 110px
        .row-title
          color #68d8fe
          font-weight 600
          font-size 16px
          margin-bottom 0.4rem
          display flex
          align-items center
          .btn
            display flex
            align-items center
            justify-content center
            width 7rem
            height 2rem
            font-size 0.8rem
            margin 0 5px
            border-radius 2px
            cursor pointer
          .btn-active
            background-color #0bace6
            color #FFFFFF
        .data-wrapper
          display flex
          flex-wrap wrap
          .data-item
            flex 1
            font-size 12px
            text-align center
            .data
              font-size 26px
            .data-title
              color #4c9bfd
              margin-top 5px
      .class-table
        height 350px
        .row-content
          padding 1.25rem 0
        .nav-title-wrapper
          padding-left 1.25rem
          margin-bottom 0.8rem
          .nav-item
            margin-right 15px
            cursor pointer
            color #1950c4
            padding-right 15px
            border-right 2px solid #00f2f1
            &:last-child
              border-right none
          .active-title
            color #FFFFFF
        .table-wrapper
          .table-head
            display flex
            width 100%
            background-color rgba(255, 255, 255, 0.1)
            color #68d8fe
            padding 0 1rem
            line-height 3rem
            .table-column
              /* flex 1 */
              text-align center
              &:nth-child(1)
                width 20%
              &:nth-child(2)
                width 30%
              &:nth-child(3)
                width 20%
              &:nth-child(4)
                width 15%
              &:nth-child(5)
                width 15%
          .table-content
            height 250px
            overflow hidden
            .table-row
              width 100%
              display flex
              padding 0 1rem
              line-height 2.5rem
              color #61a8ff
              &:hover
                background-color rgba(255, 255, 255, 0.1)
                color #68d8fe
              .table-col
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
                text-align center
                &:nth-child(1)
                  width 20%
                &:nth-child(2)
                  width 30%
                &:nth-child(3)
                  width 20%
                &:nth-child(4)
                  width 15%
                &:nth-child(5)
                  width 15%
    .center
      flex 4
      margin 3.8rem 1.5rem 0
      .map-title
        color #68d8fe
        font-size 1.6rem
        text-align center
      .echart-map
        width 100%
        /* height 440px + 4.875rem */
        height 455px
      .online
        position absolute
        top -18px
        left 0
        z-index 999
        .online-content
          width inherit
          height inherit
          position absolute
          top -40px
          left -56px
          display flex
          flex-direction column
          .title
            width 100%
            color #68d8fe
            font-size 1.6rem
            line-height 4rem
            text-align center
          .content
            flex 1
            font-size 2.4rem
            display flex
            justify-content center
            align-items center
  .table-content
    .animation-wrapper
      animation row 20s linear infinite
      &:hover
        animation-play-state paused
  .tutorial-add
    height 350px !important
    .data-wrapper
      height 90%
    .echart-tutorial-add
      width 100%
      height 100%
  .login-data
    height 340px !important
    .data-wrapper
      height 90%
    .echart-user-login
      width 100%
      height 100%
  .class-vip
    height 340px !important
    .data-wrapper
      height 90%
    .echart-class-status
      width 100%
      height 100%
  .user-all
    height 340px !important
    margin-top 4.6rem
    .flex-box
      display flex
      width 100%
      height 100%
      .flex-item
        /* flex 1 1 */
        height 100%
        .data-wrapper
          height 90%
      .left
        flex 5
      .right
        flex 2
        padding 8rem 2rem 8rem 2rem
        display flex
        flex-direction column
        justify-content space-around
        font-size 1.4rem
        color #61a8ff
        text-align center
        .line-text
          /* text-align left */
          display flex
          justify-content space-between
          span:nth-child(1)
            display flex
            align-items center
            justify-content flex-start
          span:nth-child(2)
            font-size 2.5rem
            margin-left 5px
            color #FFFFFF
            text-align left
            display block
            width 6rem
    .echart-associate-all
      width 100%
      height 100%
  @keyframes row
    0%, 100%
      transform translateY(-50%)
  .fullscreen-btn
    color #61a8ff
    cursor pointer
</style>

<style lang="stylus" scoped>
  .h290
    height 290px
  .echart-map-wrapper
    height 462px
    box-sizing border-box
    padding-bottom 42px
    display flex
    justify-content space-around
  .pie-wrapper
    // height 250px
    height 290px
    width 100%
  .line-wrapper
    // height 250px
    height 290px
  .grade-wrapper
    height 290px
  .login-wrapper
    // height 250px
    height 290px
</style>

<style lang="stylus">
  .select-wrapper
    .el-input__inner
      background-color rgba(0, 0, 0, 0)
      border-color #0b93d5
      color #68d8fe
  /* .el-select-dropdown */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
  /* .el-select-dropdown__item.hover, .el-select-dropdown__item:hover */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
</style>
